import React, {useState} from "react";
import './index.scss'
import {Button, Toast} from "antd-mobile";
import {hideLoading, showLoading} from "@/components/loading";
import Service from '../service'

const GuardsGetConfirmModal = ({ onClose, successCallBack }) => {
  const [success, setSuccess] = useState(false)
  const [count, setCount] = useState(0)
  const [date, setDate] = useState()

  const handleConfirm = async () => {
    try {
      showLoading()
      const res = await Service.receiveService()
      hideLoading()
      if (res.code !== '000000') throw res.msg;
      onClose()
      successCallBack()
      Toast.show('已领取')
    } catch (e) {
      hideLoading()
      Toast.show(e)
    }
  }
  return (
    <div className="guards-get-confirm-modal">
      <div className="guards-get-confirm-container">
        <div className="guards-get-confirm">
          <div className="guards-get-confirm-title">确认领取</div>
          <div className="guards-get-confirm-msg">恭喜集齐，每个账号限量领取一次</div>
          <div className="guards-get-confirm-btn-box">
            <div className="guards-get-btnFlex">
              <button className="guards-get-cancelBtn" onClick={onClose}>关闭</button>
            </div>
            <div className="guards-get-divider"/>
            <div className="guards-get-btnFlex">
              <Button fill="none" className="guards-get-confirmBtn" onClick={handleConfirm}>确认</Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default GuardsGetConfirmModal